import { useQuery } from "@tanstack/react-query"
import { getCruiseData } from "@services/cruiseDataService"
import { CruiseData, CruiseDataParams } from "@models/cruiseData.model"

export const useGetCruiseData = (params: CruiseDataParams | null) => {
	return useQuery<CruiseData>({
		queryKey: [
			"cruiseData",
			params?.agencyId,
			params?.countryCode,
			params?.currencyCode,
			params?.internationalRepFlag
		],
		queryFn: () => getCruiseData(params as CruiseDataParams),
		enabled: !!(
			params?.agencyId &&
			params?.countryCode &&
			params?.currencyCode !== undefined &&
			params?.internationalRepFlag !== undefined
		),
		staleTime: 5 * 60 * 1000
	})
}
